var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogledrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    clipPath: "url(#googledrive_svg__clip0_5004_1226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.923 27.608l-5.02-8.55H10.04l-5.02 8.55c.396.239.848.374 1.312.392h19.28a2.752 2.752 0 001.312-.392z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.902 19.058l5.02 8.55c.34-.22.63-.505.856-.838l3.878-6.595c.174-.352.29-.73.343-1.117H21.902z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.903 19.058h10.04a2.505 2.505 0 00-.286-1.286l-2.225-3.8L21.96 1.229a2.469 2.469 0 00-.97-.894l-5.02 8.607 2.967 5.086 2.966 5.03z",
    fill: "#FFBA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.97 8.942L20.99.335A2.087 2.087 0 0019.85 0h-7.758c-.406 0-.803.116-1.14.335l5.019 8.607z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.97 8.942L10.95.335c-.387.223-.718.528-.969.894L2.51 13.972l-2.225 3.8c-.208.397-.306.84-.285 1.286h10.04l2.965-5.086 2.966-5.03z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.04 19.058H0c0 .397.118.786.342 1.117l3.879 6.595c.21.345.504.633.856.838l4.962-8.55z",
    fill: "#0066DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "googledrive_svg__clip0_5004_1226"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v28H0z"
  })))));
}
export default SvgGoogledrive;